import { InputAdornment, StandardTextFieldProps, TextField } from '@mui/material'
import { useNavigate } from 'react-router-dom'

interface Props extends StandardTextFieldProps {
    primaryText: string
    secondaryText: string
    errorText?: string
    className?: string
    route?: string
}

const CustomOutput = ({
    className,
    primaryText,
    secondaryText,
    errorText,
    route,
    ...restOfProps
}: Props) => {
    const navigate = useNavigate()

    return (
        <TextField
            className={`overflow-hidden ${className}`}
            helperText={errorText}
            error={!!errorText}
            multiline
            InputLabelProps={{
                sx: {
                    '&.Mui-focused': {
                        color: '#434a73',
                        fontWeight: 500,
                    },
                },
            }}
            onClick={() => {
                if (route) navigate(route)
            }}
            InputProps={{
                readOnly: true,
                startAdornment: (
                    <InputAdornment position="start">
                        <div className="flex flex-col">
                            <span className="text-linkedin">{primaryText}</span>
                            <span className="text-xs">{secondaryText}</span>
                        </div>
                    </InputAdornment>
                ),
            }}
            sx={{
                '& .MuiOutlinedInput-root': {
                    '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#434a73',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#434a73',
                        color: 'red',
                    },
                },
                '&:hover label': {
                    color: '#434a73',
                },
            }}
            {...restOfProps}
        />
    )
}

export default CustomOutput
